const BrandKits = () => {
    return (
        <div>
            <h1>Assets Brand Kits</h1>
        </div>
    )
}

export default BrandKits
